import styled from 'styled-components'

import StatisticGroup from '@/common/components/StatisticGroup/StatisticGroup'

export const Group = styled(StatisticGroup)`
  flex: 1;
  width: 100%;
`
